module.exports = __webpack_public_path__ + "static/img/about_active2.06c8d1cb.png";